import { AxiosError } from 'axios';
import axiosClient from '../axiosClient';
import { POST_GROUP_EXAM_REGISTRATION_PAYMENT } from "../../constants/apiUrls";
import { useCustomMutation } from '../utils/useCustomMutation';
import {  GenericErrorResponse } from '../typings';


// =============================================================================
// Request & Response Model
// =============================================================================

export interface PostGroupExamRegistrationPaymentResponse {
  internalTransactionRef: string;
  transactionAmount: number;
  paymentSuccess: boolean;
}

export interface PostGroupExamRegistrationPaymentRequest {
  uuid: string;
  paymentMode: string;
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: (data: PostGroupExamRegistrationPaymentResponse) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
  onSettled?: () => void;
}

export const usePostGroupExamRegistrationPayment = ({
  onSuccess,
  onError,
  onSettled,
}: Input) => {
  const postGroupExamRegistrationPayment = async (
    payload: PostGroupExamRegistrationPaymentRequest
  ) => {
    const res = await axiosClient.post<PostGroupExamRegistrationPaymentResponse>(
      POST_GROUP_EXAM_REGISTRATION_PAYMENT,
      payload
    );
    return res.data;
  };

  return useCustomMutation(
    postGroupExamRegistrationPayment,
    {
      onSuccess,
      onError,
      onSettled,
    },
  );
};
